import {
  COLOR_SWATCH_BORDER_RADIUS_PX,
  COLOR_SWATCH_PADDING_PX,
  COLOR_SWATCH_SIZE_PX,
} from './heatmap-stop-layout';

/**
 * @intent CSS values for painting colour swatches, bound to Modus theme tokens
 * so swatch styling tracks the active theme. Numeric layout constants in
 * `heatmap-stop-layout.ts` stay the source of truth for JS geometry/handle
 * alignment maths; these strings are styling-only and carry those same px values
 * as `var(..., fallback)` so paint and layout cannot drift.
 *
 * Token → px mapping (Modus modern light):
 * - `--modus-wc-size-xs`         → 24px (inner swatch button)
 * - `--modus-wc-spacing-2xs`     → 2px  (wrapper padding)
 * - `--modus-wc-border-radius-md`→ 4px  (inner swatch radius)
 * - `--modus-wc-border-radius-sm`→ 2px  (outer wrapper radius)
 */
export const COLOR_SWATCH_SIZE_CSS = `var(--modus-wc-size-xs, ${String(
  COLOR_SWATCH_SIZE_PX
)}px)`;

export const COLOR_SWATCH_PADDING_CSS = `var(--modus-wc-spacing-2xs, ${String(
  COLOR_SWATCH_PADDING_PX
)}px)`;

export const COLOR_SWATCH_BORDER_RADIUS_CSS = `var(--modus-wc-border-radius-md, ${String(
  COLOR_SWATCH_BORDER_RADIUS_PX
)}px)`;

export const COLOR_SWATCH_WRAPPER_BORDER_RADIUS_CSS =
  'var(--modus-wc-border-radius-sm, 2px)';
